import React from 'react';
import { useSelectPaymentPanel } from './useSelectPaymentPanel';
import { OutstandingPaymentTable } from '../outstandingPaymentTable/outstandingPaymentTable';
import Loading from '../../shared/Loading/Loading';

export const SelectPayment = () => {
  const { petDetailsLoading, getOutstandingPolicyPaymentIsLoading, validateOutstandingPaymentIsLoading } =
    useSelectPaymentPanel();

  return (
    <div>
      {petDetailsLoading || getOutstandingPolicyPaymentIsLoading || validateOutstandingPaymentIsLoading ? (
        <Loading />
      ) : (
        <OutstandingPaymentTable />
      )}
    </div>
  );
};
